import { MEDIA } from '~/consts';

export const state = () => ({
  lists: [],
  downloads: []
})

export const mutations = {
  setLists(state, val) {
    state.lists = val;
  },
  setDownloadProgress(state, item) {
    let items = collect(state.downloads)
    let exist_item = items.where('uid', '==', item.uid).first()

    if (!helpers.isEmpty(exist_item)) {
      items = items.map((i) => {
        if (i.uid == item.uid) {
          i['progress'] = item.progress
        }

        return i
      })
    } else {
      items.push(item)
    }

    items = items.filter((i) => !helpers.isEmpty(i.progress) && i.progress > 0)

    state.downloads = items.toArray()
  },
  clearDownloads(state) {
    state.downloads = []
  }
}

export const actions = {
  getAll ({ commit }) {
    let postData = {};
    if (helpers.isEmpty(this.state.auth)) {
      return;
    }

    let pt = this.state.auth.active_pt;

    if (!helpers.isEmpty(pt)) {
      postData = {
        university_user_id: pt.id
      }
    }

    postData['dataProvider'] = JSON.stringify({ page: { limit: 100 } });

    this.$axios.post(MEDIA.GET_ALL, postData)
      .then(({ data }) => {
        const medias = collect(data.data.data).values().toArray();

        if (data.applicationSystem.code == 0 && !helpers.isEmpty(medias)) {
          commit('setLists', medias);
        }
      })
  }
}
